module.exports = __webpack_public_path__ + "static/img/afc.2a7dfe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/afc.png
// module id = tq+5
// module chunks = 0